

exports.__esModule = true;
var store = {};

// Polyfill for sessionStorage if not available. Simple variable store
exports['default'] = window.sessionStorage || {
    getItem: function getItem(key) {
        if (arguments < 1) {
            throw new Error('1 argument required');
        }
        return store[key];
    },
    setItem: function setItem(key, val) {
        if (arguments < 2) {
            throw new Error('2 arguments required');
        }
        store[key] = val;
    }
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./components/xo-venmo-components/src/venmo-info/sessionStorage.js
// module id = ./components/xo-venmo-components/src/venmo-info/sessionStorage.js
// module chunks = 1